<template>
  <tr
    :key="item.id"
    class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50 hover:tw-bg-primary-50/60 tw-duration-100"
  >
    <!-- ID Column -->
    <td class="tw-px-5 tw-py-3 tw-text-sm tw-font-medium tw-text-gray-900">
      {{ item.id }}
    </td>

    <!-- Image Column -->
    <td class="tw-px-5 tw-py-3">
      <div class="tw-w-12 tw-h-12 tw-flex-shrink-0">
        <img
          v-if="item.image"
          :src="item.image"
          :alt="item.name"
          class="tw-w-12 tw-h-12 tw-rounded-lg tw-object-cover tw-border tw-border-gray-200"
        />
        <div
          v-else
          class="tw-w-12 tw-h-12 tw-bg-gray-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-border tw-border-gray-200"
        >
          <icon icon="solar:settings-linear" class="tw-text-gray-400 tw-text-lg" />
        </div>
      </div>
    </td>

    <!-- Name Column -->
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-font-medium tw-text-gray-900 tw-truncate tw-max-w-[200px]" :title="item.name">
        {{ item.name }}
      </div>
    </td>

    <!-- Description Column -->
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-text-gray-600 tw-max-w-[250px] tw-truncate" :title="item.description">
        {{ item.description || 'No description' }}
      </div>
    </td>

    <!-- Categories Column -->
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-flex tw-gap-1 tw-overflow-hidden tw-max-w-[180px]">
        <template v-if="item.categories && item.categories.length > 0">
          <div class="tw-flex tw-gap-1 tw-overflow-hidden tw-flex-1">
            <span
              v-for="category in item.categories.slice(0, 2)"
              :key="category.id"
              class="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-medium tw-bg-primary-100 tw-text-primary-800 tw-min-w-0 tw-flex-shrink tw-overflow-hidden"
              :title="category.name"
            >
              <span class="tw-truncate">{{ category.name }}</span>
            </span>
          </div>
          <span
            v-if="item.categories.length > 2"
            class="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-medium tw-bg-gray-100 tw-text-gray-800 tw-flex-shrink-0"
            :title="`${item.categories.length - 2} more categories`"
          >
            +{{ item.categories.length - 2 }}
          </span>
        </template>
        <span v-else class="tw-text-gray-400 tw-text-xs">No categories</span>
      </div>
    </td>

    <!-- Company Column -->
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <div class="tw-font-medium tw-text-gray-900 tw-truncate tw-max-w-[150px]" :title="item.company?.name">
        {{ item.company?.name || 'No company' }}
      </div>
    </td>

    <!-- Status Column -->
    <td class="tw-px-5 tw-py-3 tw-text-sm">
      <span
        :class="[
          'tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium',
          item.status === 'active' 
            ? 'tw-bg-green-100 tw-text-green-800' 
            : 'tw-bg-red-100 tw-text-red-800'
        ]"
      >
        {{ item.status === 'active' ? 'Active' : 'Inactive' }}
      </span>
    </td>

    <!-- Created Date Column -->
    <td class="tw-px-5 tw-py-3 tw-text-sm tw-text-gray-600">
      {{ formatDate(item.created_at) }}
    </td>

    <!-- Actions Column -->
    <td class="tw-px-5 tw-py-3">
      <AdminServiceTableActions 
        :item="item"
        @edit="$emit('edit', item)"
        @delete="$emit('delete', item)"
      />
    </td>
  </tr>
</template>

<script setup>
/* eslint-disable */
import AdminServiceTableActions from './AdminServiceTableActions.vue';

defineProps({
  item: {
    type: Object,
    required: true
  }
});

defineEmits(['edit', 'delete']);
/* eslint-enable */

const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};
</script>

<style scoped>
/* Add any custom styles here */
</style> 